module.exports = __webpack_public_path__ + "static/tao_te_ching-4eb70e1938f08a292df9580368754294.png";